(function() {
  'use strict';

  function setFieldError(field, hasError) {
    field.setAttribute('aria-invalid', hasError ? 'true' : 'false');

    var wrapper = field.closest('.team-order-details__field');
    var error = wrapper ? wrapper.querySelector('[data-team-order-error]') : null;

    if (error) {
      error.hidden = !hasError;
    }
  }

  function setupTeamOrder(section) {
    if (section.getAttribute('data-team-order-initialized') === 'true') {
      return;
    }

    var form = section.closest('form');
    var toggle = section.querySelector('[data-team-order-toggle]');
    var panel = section.querySelector('[data-team-order-panel]');
    var fields = section.querySelectorAll('[data-team-order-field]');
    var requiredFields = section.querySelectorAll('[data-team-order-required]');
    var variantProperty = section.querySelector('[data-team-order-variant-property]');
    var sizeProperty = section.querySelector('[data-team-order-size-property]');
    var quantityProperty = section.querySelector('[data-team-order-quantity-property]');

    if (!form || !toggle || !panel) {
      return;
    }

    section.setAttribute('data-team-order-initialized', 'true');

    function selectedOptionText(select) {
      if (!select || select.selectedIndex < 0) {
        return '';
      }

      return select.options[select.selectedIndex].text.trim();
    }

    function selectedSize() {
      var selectors = form.querySelectorAll('.selector-wrapper');
      var size = '';

      Array.prototype.forEach.call(selectors, function(wrapper) {
        var label = wrapper.querySelector('label');
        var select = wrapper.querySelector('select');
        var labelText = label ? label.textContent.trim().toLowerCase() : '';

        if (labelText === 'size') {
          size = selectedOptionText(select);
        }
      });

      return size;
    }

    function syncOrderProperties() {
      var variantSelect = form.querySelector('select[name="id"]');
      var quantityInput = form.querySelector('input[name="quantity"]');

      if (variantProperty) {
        variantProperty.value = selectedOptionText(variantSelect);
      }

      if (sizeProperty) {
        sizeProperty.value = selectedSize();
      }

      if (quantityProperty) {
        quantityProperty.value = quantityInput ? quantityInput.value : '1';
      }
    }

    function updateState() {
      var isActive = toggle.checked;

      panel.hidden = !isActive;
      toggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      section.classList.toggle('is-active', isActive);

      Array.prototype.forEach.call(fields, function(field) {
        field.disabled = !isActive;
      });

      Array.prototype.forEach.call(requiredFields, function(field) {
        field.required = isActive;
        field.setAttribute('aria-required', isActive ? 'true' : 'false');
        setFieldError(field, false);
      });

      if (isActive) {
        syncOrderProperties();
      }
    }

    function validate(event) {
      if (!toggle.checked) {
        return;
      }

      syncOrderProperties();

      var firstInvalidField = null;

      Array.prototype.forEach.call(requiredFields, function(field) {
        var isInvalid = !field.value.trim();
        setFieldError(field, isInvalid);

        if (isInvalid && !firstInvalidField) {
          firstInvalidField = field;
        }
      });

      if (!firstInvalidField) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      panel.hidden = false;
      firstInvalidField.focus();
    }

    toggle.addEventListener('change', updateState);
    form.addEventListener('submit', validate, true);
    form.addEventListener('change', function() {
      window.setTimeout(syncOrderProperties, 0);
    });

    var quantityInput = form.querySelector('input[name="quantity"]');
    if (quantityInput) {
      quantityInput.addEventListener('input', syncOrderProperties);
    }

    Array.prototype.forEach.call(requiredFields, function(field) {
      field.addEventListener('input', function() {
        setFieldError(field, false);
      });
    });

    syncOrderProperties();
    updateState();
  }

  function initializeTeamOrders(root) {
    var sections = root.querySelectorAll('[data-team-order-section]');

    Array.prototype.forEach.call(sections, setupTeamOrder);
  }

  function initializeDocument() {
    initializeTeamOrders(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeDocument);
  } else {
    initializeDocument();
  }

  document.addEventListener('shopify:section:load', function(event) {
    initializeTeamOrders(event.target);
  });
})();
